import { tUnchecked } from '@glow/language'
import i18next from 'i18next'
import { Card, Text } from '../../atoms'
import { CategoryColumn } from '../moveable-card'

export const ImmobileCard = ({ column, index }: { column: CategoryColumn; index: number }) => (
  <Card className="cursor-not-allowed bg-gray-100! mt-2 mx-2 p-4 last:mb-2 grid grid-cols-[auto_20px] items-center">
    <div>
      <Text as="span" textType="sm" semiBold className="text-emphasis-high mr-2">
        <span className="mr-1">{index + 1}.</span>
        {column.label}
      </Text>
      <Text as="span" textType="sm">
        {i18next.exists(`columnCategories.${column.category}`)
          ? tUnchecked(`columnCategories.${column.category}`)
          : column.category}
      </Text>
    </div>
  </Card>
)
